import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { EXPERIENCES } from "@/data/content";
import { FadeUp, SectionHeading } from "./Reveal";

export const Experiences = () => (
  <section id="experiences" data-testid="experiences-section" className="mx-auto max-w-7xl px-6 py-28 lg:px-10 lg:py-36">
    <FadeUp className="flex flex-wrap items-end justify-between gap-8">
      <SectionHeading overline="Tours & Experiences" title="What will you do when you arrive?" />
      <Link
        to="/experiences"
        data-testid="experiences-browse-cta"
        className="flex items-center gap-1.5 border border-jawa-espresso/25 px-6 py-3 text-xs font-semibold uppercase tracking-[0.25em] text-jawa-espresso transition-colors hover:border-jawa-coral hover:text-jawa-coral"
      >
        All tours & experiences <ArrowUpRight className="h-4 w-4" />
      </Link>
    </FadeUp>

    <div className="mt-14 grid grid-cols-2 gap-5 md:grid-cols-5">
      {EXPERIENCES.map((e, i) => (
        <FadeUp key={e.name} delay={i * 0.05}>
          <Link
            to={e.href}
            data-testid={`experience-card-${e.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
            className="group relative block h-44 overflow-hidden md:h-52"
          >
            <img
              src={e.image}
              alt={e.name}
              loading="lazy"
              decoding="async"
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-jawa-nearblack/75 via-transparent to-transparent" />
            <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between gap-2">
              <p className="font-serif text-lg font-medium text-jawa-ivory">{e.name}</p>
              <ArrowUpRight className="h-4 w-4 shrink-0 text-jawa-turquoise opacity-0 transition-opacity group-hover:opacity-100" />
            </div>
          </Link>
        </FadeUp>
      ))}
    </div>
  </section>
);
